// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carbon-calculator-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    max-width: 600px;
    margin: 0 auto;
    margin-top: 20px;
  }
  
  .carbon-calculator-container h1 {
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
  }
  
  .input-group {
    margin-bottom: 15px;
    width: 100%;
  }
  
  .input-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
    color: #555;
  }
  
  .input-group input,
  .input-group select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    color: #333;
  }
  
  .fuel-type-tabs {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 15px;
  }
  
  .fuel-tab {
    flex: 1 1;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #f9f9f9;
    cursor: pointer;
    text-align: center;
    font-size: 16px;
    color: #333;
    margin-right: 10px;
  }
  
  .fuel-tab:last-child {
    margin-right: 0;
  }
  
  .fuel-tab.active {
    background-color: #007bff;
    color: #fff;
    border-color: #007bff;
  }
  
  .calculate-button {
    padding: 12px 24px;
    background-color: green;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 18px;
    margin-top: 20px;
  }
  
  .calculate-button:hover {
    background-color: #0056b3;
  }
  
  .result {
    margin-top: 20px;
    text-align: center;
  }
  
  .result h2 {
    margin-bottom: 10px;
    font-size: 22px;
    color: #333;
  }
  
  .result p {
    font-size: 20px;
    font-weight: bold;
    color: #007bff;
  }

  @media (min-width: 600px) {
    .input-group {
        flex-direction: column;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/CarbonCalculator.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".carbon-calculator-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 30px;\n    background-color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    max-width: 600px;\n    margin: 0 auto;\n    margin-top: 20px;\n  }\n  \n  .carbon-calculator-container h1 {\n    margin-bottom: 20px;\n    font-size: 24px;\n    color: #333;\n  }\n  \n  .input-group {\n    margin-bottom: 15px;\n    width: 100%;\n  }\n  \n  .input-group label {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: bold;\n    color: #555;\n  }\n  \n  .input-group input,\n  .input-group select {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 16px;\n    color: #333;\n  }\n  \n  .fuel-type-tabs {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 15px;\n  }\n  \n  .fuel-tab {\n    flex: 1;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: #f9f9f9;\n    cursor: pointer;\n    text-align: center;\n    font-size: 16px;\n    color: #333;\n    margin-right: 10px;\n  }\n  \n  .fuel-tab:last-child {\n    margin-right: 0;\n  }\n  \n  .fuel-tab.active {\n    background-color: #007bff;\n    color: #fff;\n    border-color: #007bff;\n  }\n  \n  .calculate-button {\n    padding: 12px 24px;\n    background-color: green;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 18px;\n    margin-top: 20px;\n  }\n  \n  .calculate-button:hover {\n    background-color: #0056b3;\n  }\n  \n  .result {\n    margin-top: 20px;\n    text-align: center;\n  }\n  \n  .result h2 {\n    margin-bottom: 10px;\n    font-size: 22px;\n    color: #333;\n  }\n  \n  .result p {\n    font-size: 20px;\n    font-weight: bold;\n    color: #007bff;\n  }\n\n  @media (min-width: 600px) {\n    .input-group {\n        flex-direction: column;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
